import { render, staticRenderFns } from "./PlayerControls.vue?vue&type=template&id=77245a14&scoped=true&"
import script from "./PlayerControls.vue?vue&type=script&lang=js&"
export * from "./PlayerControls.vue?vue&type=script&lang=js&"
import style0 from "./PlayerControls.vue?vue&type=style&index=0&id=77245a14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77245a14",
  null
  
)

export default component.exports